import React, { useCallback, useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import "./index.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import {
  getApi,
  getCityAreas,
  patchProductVariant,
  postGetCalculatedprice,
  postProductVariant,
} from "../../../../actions/structure.action";
import isEmpty from "../../../../utils/is-Empty";
import CustomSelectDropdown from "../../../common/CustomSelectDropdown";
import { appConstants, areaList, regex, stringConstants } from "../../../../helpers/app-constants";
import CustomDragDrop from "../../../common/CustomDragDrop";
import CustomImagesDrageDrop from "../../../common/CustomImagesDrageDrop";
import debounce from "lodash/debounce";
import getSellerDefaultAddress from "../../../../utils/getSellerDefaultAddress";
import { useDialog } from "../../../../helpers/useDialog";
import { capitalize } from "lodash";

const VariantsCrud = ({
  variant = {},
  createVariant = {},
  createVariantOptions = [],
  setShowVariantCRUD,
  renderInfo = {},
  isViewOnly = false,
}) => {
  const dispatch = useDispatch();
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [currentUpdateId, setCurrentUpdateId] = useState("");
  const [selectedFormObj, setSelectedFormObj] = useState({});
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [cityAreaData, setCityAreaData] = useState([]);
  const [moqList, setMoqList] = useState([]);
  const { alert, DialogModal } = useDialog();

  const {
    bhareeAdminBasicTable,
    requestCall,
    calculatedPrice,
    addresses,
    auth,
    userSubscriptionInfo,
  } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    if (auth.loggedIn && !isEmpty(auth?.user)) {
      getApi("getAddressess", dispatch);
    }
  }, [dispatch, auth]);

  useEffect(() => {
    setDefaultAddress(getSellerDefaultAddress(addresses, auth));
  }, [addresses, auth]);

  useEffect(() => {
    if (!isEmpty(defaultAddress)) {
      getCityAreas(dispatch, defaultAddress?.city).then((response) => {
        if (response?.payload?.length > 0) {
          setCityAreaData(response.payload);
        }
      });
    }
  }, [defaultAddress, dispatch]);

  useEffect(() => {
    setMoqList(bhareeAdminBasicTable?.data?.moqs?.sort((a, b) => a.quantity - b.quantity));
  }, [bhareeAdminBasicTable]);

  useEffect(() => {
    // console.log("userSubscriptionInfo: ", userSubscriptionInfo);
    // console.log("bhareeAdminBasicTable?.data?.moqs: ", bhareeAdminBasicTable?.data?.moqs);
    if (auth?.user?.role?.role_name === stringConstants.ROLL_SELLER) {
      if (userSubscriptionInfo && !isEmpty(userSubscriptionInfo?.data)) {
        const allowedMOQ =
          userSubscriptionInfo?.data?.subscriptionFeatures?.moq ||
          userSubscriptionInfo?.data?.sellerInfo?.subscriptionFeatures?.moq;
        // console.log("Allowed MOQ: ", allowedMOQ);
        if (allowedMOQ <= 50) {
          const filteredMOQs =
            bhareeAdminBasicTable?.data?.moqs
              ?.filter((item) => item.quantity <= 50)
              ?.sort((a, b) => a.quantity - b.quantity) || [];
          setMoqList(filteredMOQs);
        }
      }
    }
  }, [userSubscriptionInfo, auth, bhareeAdminBasicTable]);

  const onSelectValue = (value, selectorType) => {
    let updatedObj = {};
    updatedObj[selectorType] = value;
    setSelectedFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const handleFileChange = (files) => {
    // const files = e.target.files;
    console.log("**********files", files);
    const newImageData = [];

    for (let i = 0; i < files?.length; i++) {
      const imageKey = `image_${i + 1}`; // Generate a unique key for each image
      newImageData.push({ key: imageKey, file: files[i] });
    }

    if (Object.prototype.hasOwnProperty.call(selectedFormObj, "imageData")) {
      setSelectedFormObj((prevState) => {
        const newArray = [...prevState.imageData];
        newImageData.map((item) => {
          return newArray.push(item);
        });
        return { ...prevState, imageData: newArray };
      });
    } else {
      // let updatedObj = {};
      // updatedObj["imageData"] = newImageData;
      console.log("newImageData: ", newImageData);
      setSelectedFormObj((previousValues) => ({
        ...previousValues,
        imageData: newImageData,
      }));
    }
  };

  useEffect(() => {
    console.log("selectedFormObj updated:", selectedFormObj);
  }, [selectedFormObj]);

  useEffect(() => {
    if (!isEmpty(variant)) {
      setSelectedFormObj(variant);
      setIsUpdateMode(true);
      setCurrentUpdateId(variant.id);
    } else {
      setIsUpdateMode(false);
      setSelectedFormObj(createVariant);
    }

    dispatch({
      type: appConstants.CLEAR_CALCULATED_PRICE,
    });
  }, []);

  const objectToFormData = (obj, formData, parentKey = "") => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        const formKey = parentKey ? `${parentKey}[${key}]` : key;

        if (typeof value === "object" && !Array.isArray(value)) {
          objectToFormData(value, formData, formKey);
        } else if (Array.isArray(value)) {
          if (value?.length > 0) {
            value.forEach((item, index) => {
              const arrayFormKey = `${formKey}[${index}]`;
              objectToFormData(item, formData, arrayFormKey);
            });
          } else {
            formData.append(formKey, []);
          }
        } else {
          formData.append(formKey, value);
        }
      }
    }

    return formData;
  };

  const createUpdateProductVariant = (e) => {
    e.preventDefault();

    console.log("createUpdateProductVariant: ", selectedFormObj);

    if (!isEmpty(selectedFormObj)) {
      const formData = new FormData();
      objectToFormData(
        {
          ...selectedFormObj,
          price: isUpdateMode ? selectedFormObj?.seller_base_price : selectedFormObj?.price,
          city: selectedFormObj?.city || defaultAddress?.city,
          district: selectedFormObj?.district || defaultAddress?.district,
        },
        formData,
      );

      console.log("IMAGE DATA: ", selectedFormObj?.imageData);
      if (
        Object.prototype.hasOwnProperty.call(selectedFormObj, "imageData") &&
        selectedFormObj?.imageData?.length > 0
      ) {
        console.log("I am inside...");
        selectedFormObj?.imageData.map((img) => {
          console.log("I am appending...");
          return formData.append(img?.key, img?.file);
        });
      }

      if (isUpdateMode) {
        patchProductVariant(currentUpdateId, formData, dispatch);
      } else {
        postProductVariant(formData, dispatch);
      }
    }
  };

  const debouncedUpdatePrice = useCallback(
    debounce((id, value) => {
      let obj = {};
      obj["variantId"] = id;
      obj["price"] = value;
      postGetCalculatedprice(obj, dispatch);
    }, 1000), // Adjust delay as needed
    [],
  );

  const handlePriceChange = (id, value, selectorType) => {
    // console.log("*******", id);
    onSelectValue(value, selectorType);
    debouncedUpdatePrice(id, value);
  };

  const showPriceInfo = () => {
    // console.log("selected obj: ", selectedFormObj);
    // console.log("variant_id: ", selectedFormObj?.variant?.id);
    // console.log("calculated price: ", calculatedPrice);
    const mPriceInfo = isEmpty(calculatedPrice?.data[selectedFormObj?.variant?.id])
      ? selectedFormObj
      : calculatedPrice?.data[selectedFormObj?.variant?.id];

    // console.log("Price Info: ", mPriceInfo);
    let totalPrice =
      parseFloat(mPriceInfo?.seller_price) +
      parseFloat(mPriceInfo?.bhareeComm) +
      parseFloat(mPriceInfo?.transactionFee) +
      parseFloat(mPriceInfo?.gst);

    totalPrice =
      totalPrice - parseInt(totalPrice) > 0.5
        ? Math.ceil(totalPrice).toFixed(2)
        : Math.floor(totalPrice).toFixed(2);

    const mHtmlMessage = `
    <div class="row">
      <div class="col-md-6 text-end small"><strong>Seller Base Price:</strong></div>
      <div class="col-md-3 text-end">${parseFloat(mPriceInfo?.seller_base_price).toFixed(2)} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <div class="row">
      <div class="col-md-6 text-end small"><strong>CGST (${(parseFloat(mPriceInfo?.hsn_gst) / 2).toFixed(1)}%):</strong></div>
      <div class="col-md-3 text-end">${parseFloat(mPriceInfo?.seller_cgst).toFixed(2)} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <div class="row">
      <div class="col-md-6 text-end small"><strong>SGST (${(parseFloat(mPriceInfo?.hsn_gst) / 2).toFixed(1)}%):</strong></div>
      <div class="col-md-3 text-end">${parseFloat(mPriceInfo?.seller_sgst).toFixed(2)} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6 text-end small"><strong>Seller Base Price (with GST):</strong></div>
      <div class="col-md-3 text-end">${parseFloat(mPriceInfo?.seller_price).toFixed(2)} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <div class="row">
      <div class="col-md-6 text-end small"><strong>Bharee ${capitalize(
        mPriceInfo?.bhareeCommType,
      )} Fee (${(
        (parseFloat(mPriceInfo?.bhareeComm) / parseFloat(mPriceInfo?.seller_price)) *
        100
      ).toFixed(1)}%):</strong></div>
      <div class="col-md-3 text-end">${mPriceInfo?.bhareeComm} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <div class="row">
      <div class="col-md-6 text-end small"><strong>Platform Fee (${(
        (parseFloat(mPriceInfo?.transactionFee) / parseFloat(mPriceInfo?.seller_price)) *
        100
      ).toFixed(1)}%):</strong></div>
      <div class="col-md-3 text-end">${mPriceInfo?.transactionFee} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <div class="row">
      <div class="col-md-6 text-end small"><strong>Bharee GST (${
        ((parseFloat(mPriceInfo?.gst) / parseFloat(mPriceInfo?.bhareeComm)) * 100).toFixed(0) + ".0"
      }%):</strong></div>
      <div class="col-md-3 text-end">${mPriceInfo?.gst} ₹</div>
      <div class="col-md-3"></div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-6 text-end small"><strong>Final Total:</strong></div>
      <div class="col-md-3 text-end">${totalPrice} ₹</div>
      <div class="col-md-3 small text-start">(rounded)</div>
    </div>
    `;
    alert(mHtmlMessage);
  };

  return (
    <>
      {DialogModal}
      <Row className="m-0 w-full  form-row ">
        <Row className="m-0 px-0 w-full px-0 mb-4 title-button-row">
          <h2>{!isUpdateMode ? "Add Variant" : "Update Variant"}</h2>
          <CustomButton buttonClasses="view-switch-btn" onClick={() => setShowVariantCRUD(false)}>
            {"List"}
          </CustomButton>
        </Row>

        {createVariantOptions?.length < 1 && !isUpdateMode ? (
          <Container>
            <p className="text-center">
              {"All variants have already been created. No additional variants are available."}
            </p>
          </Container>
        ) : (
          <Form className="modal-custom-class  px-0" onSubmit={createUpdateProductVariant}>
            <Row className="m-0 px-0">
              <h6 className="px-3 mb-2">
                {!isUpdateMode ? "Please Select " : selectedFormObj?.displayName}
                {" Variant"}
              </h6>
              {!isUpdateMode && (
                <Col xs={12} md={6} lg={4} className="px-3">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Variant"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>
                    <CustomSelectDropdown
                      style={{
                        multiselectContainer: {
                          backgroundColor: "#f8f8f8",
                        },
                        chips: {
                          margin: 0,
                        },
                        option: {
                          background: "#fbb040",
                          color: "#FFFFFF",
                          borderBottom: "1px solid #FFFFFF",
                        },
                      }}
                      options={createVariantOptions}
                      onSelect={(e) => {
                        onSelectValue(e[0], "variant");
                      }}
                      // onRemove={(e) => {
                      //     onSelectValue(e, "moq");
                      // }}
                      selectedValues={
                        Object.prototype.hasOwnProperty.call(selectedFormObj, "variant")
                          ? [selectedFormObj?.variant]
                          : []
                      }
                      singleSelect
                      displayValue={"displayName"}
                    />
                  </Form.Group>
                </Col>
              )}

              <Col xs={12} md={6} lg={4} className="px-3">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>
                    {"MOQ's"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <CustomSelectDropdown
                    style={{
                      multiselectContainer: {
                        backgroundColor: "#f8f8f8",
                      },
                      chips: {
                        background: "#fbb040",
                        margin: 0,
                      },
                      option: {
                        background: "#fbb040",
                        color: "#FFFFFF",
                        borderBottom: "1px solid #FFFFFF",
                      },
                    }}
                    options={moqList}
                    onSelect={(e) => {
                      onSelectValue(e, "moq");
                    }}
                    onRemove={(e) => {
                      onSelectValue(e, "moq");
                    }}
                    selectedValues={
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "moq")
                        ? selectedFormObj?.moq
                        : []
                    }
                    displayValue={"displayName"}
                  />
                </Form.Group>
              </Col>

              {!isUpdateMode ? (
                <Col xs={12} md={6} lg={4} className="px-3">
                  <Form.Label>
                    {"Base Price Per Case [ in ₹ ]"}
                    <span className="redStreSpan">{"*"}</span>
                    {!isEmpty(calculatedPrice?.data) &&
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "variant") &&
                      Object.prototype.hasOwnProperty.call(
                        calculatedPrice?.data,
                        selectedFormObj?.variant.id,
                      ) && (
                        <span className="positiveMsg pointer" onClick={showPriceInfo}>
                          {" "}
                          {" Final Price : " +
                            calculatedPrice?.data[selectedFormObj?.variant?.id].offer_price}{" "}
                          <i className="bi bi-info-circle"></i>
                        </span>
                      )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    maxLength={10}
                    value={
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "price")
                        ? selectedFormObj?.price
                        : ""
                    }
                    onChange={(e) => {
                      return regex.test(e.target.value)
                        ? handlePriceChange(selectedFormObj?.variant?.id, e.target.value, "price")
                        : null;
                    }}
                  />
                  <p className="m-0 py-0 pb-1 text-danger small">
                    * Please enter your base price without GST
                  </p>
                </Col>
              ) : (
                <Col xs={12} md={6} lg={4} className="px-3">
                  <Form.Label>
                    {"Base Price Per Case [ in ₹ ]"}
                    <span className="redStreSpan">{"*"}</span>
                    {!isEmpty(calculatedPrice?.data) &&
                    Object.prototype.hasOwnProperty.call(
                      calculatedPrice?.data,
                      selectedFormObj?.variant_id,
                    ) ? (
                      <span className="positiveMsg pointer" onClick={showPriceInfo}>
                        {" "}
                        {" Final Price : " +
                          calculatedPrice?.data[selectedFormObj?.variant_id].offer_price}{" "}
                        <i className="bi bi-info-circle"></i>
                      </span>
                    ) : (
                      <span className="positiveMsg pointer" onClick={showPriceInfo}>
                        {" "}
                        {" Final Price : " + selectedFormObj?.price}{" "}
                        <i className="bi bi-info-circle"></i>
                      </span>
                    )}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    maxLength={10}
                    value={
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "seller_base_price")
                        ? selectedFormObj?.seller_base_price
                        : ""
                    }
                    onChange={(e) => {
                      return regex.test(e.target.value)
                        ? handlePriceChange(
                            selectedFormObj?.variant_id,
                            e.target.value,
                            "seller_base_price",
                          )
                        : null;
                    }}
                  />
                  {/* <p className="m-0 py-0 pb-1 text-danger small">
                    * Price displayed is inclusive of GST
                  </p> */}
                  <p className="m-0 py-0 pb-1 text-danger small">
                    * Please enter your base price without GST if you wish to change it
                  </p>
                </Col>
              )}

              <Col xs={12} md={6} lg={4} className="px-3">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>
                    {"Packaging Types"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <CustomSelectDropdown
                    style={{
                      multiselectContainer: {
                        backgroundColor: "#f8f8f8",
                      },
                      chips: {
                        margin: 0,
                      },
                      option: {
                        background: "#fbb040",
                        color: "#FFFFFF",
                        borderBottom: "1px solid #FFFFFF",
                      },
                    }}
                    options={bhareeAdminBasicTable?.data?.packagingTypes}
                    onSelect={(e) => {
                      onSelectValue(e[0], "packaging_type");
                      // onSelectValue(e[0], `_${variant.quantity}.packaging_type`)
                    }}
                    selectedValues={
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "packaging_type")
                        ? [selectedFormObj?.packaging_type]
                        : []
                    }
                    displayValue={"name"}
                    singleSelect
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6} lg={4} className="px-3">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>
                    {"Packaging Size [Bottles]"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    maxLength={10}
                    value={
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "packaging_size")
                        ? selectedFormObj?.packaging_size
                        : ""
                    }
                    onChange={(e) => {
                      return regex.test(e.target.value)
                        ? onSelectValue(e.target.value, "packaging_size")
                        : null;
                    }}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} md={6} lg={4} className="px-3">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>
                    {"Weight Per Case [in kg]"}
                    <span className="redStreSpan">{"*"}</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    required
                    maxLength={10}
                    value={
                      Object.prototype.hasOwnProperty.call(selectedFormObj, "weight_per_case")
                        ? selectedFormObj?.weight_per_case
                        : ""
                    }
                    onChange={(e) => {
                      return regex.test(e.target.value)
                        ? onSelectValue(e.target.value, "weight_per_case")
                        : null;
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="m-0 px-0">
              <Col xs={12} md={4} lg={4} className="px-3">
                <Form.Group className="mb-3">
                  <Form.Label>All Areas (City: {defaultAddress?.city})</Form.Label>
                  <Form.Check
                    type="checkbox"
                    label="Enable"
                    checked={selectedFormObj?.all_areas === 1}
                    onChange={(e) => {
                      setSelectedFormObj((previousValues) => ({
                        ...previousValues,
                        all_areas: e.target.checked ? 1 : 0,
                        area_list: [],
                      }));
                    }}
                  />
                </Form.Group>
              </Col>
              {selectedFormObj?.all_areas !== 1 && (
                <Col xs={12} md={8} lg={8} className="px-3">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Areas"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>
                    <CustomSelectDropdown
                      disable={selectedFormObj?.all_areas === 1 ? true : false}
                      style={{
                        multiselectContainer: {
                          backgroundColor: "#f8f8f8",
                        },
                        chips: {
                          background: "#fbb040",
                          margin: 0,
                        },
                        option: {
                          background: "#fbb040",
                          color: "#FFFFFF",
                          borderBottom: "1px solid #FFFFFF",
                        },
                      }}
                      options={cityAreaData}
                      onSelect={(e) => {
                        onSelectValue(e, "area_list");
                      }}
                      onRemove={(e) => {
                        onSelectValue(e, "area_list");
                      }}
                      selectedValues={
                        Object.prototype.hasOwnProperty.call(selectedFormObj, "area_list")
                          ? selectedFormObj?.area_list
                          : []
                      }
                      displayValue={"area"}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>
            <Row className="m-0 px-0">
              {/* <Col xs={12} md={6} lg={4} className="px-3">
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>
                                    {"payment Types"}
                                    <span className="redStreSpan">{"*"}</span>
                                </Form.Label>
                                <CustomSelectDropdown
                                    style={{
                                        multiselectContainer: {
                                            backgroundColor: "#f8f8f8",
                                        },
                                        chips: {
                                            background: "#fbb040",
                                        },
                                        option: {
                                            background: "#fbb040",
                                            color: "#FFFFFF",
                                            borderBottom: "1px solid #FFFFFF",
                                        },
                                    }}
                                    options={bhareeAdminBasicTable?.data.paymentTypes}
                                    onSelect={(e) => {
                                        onSelectValue(
                                            e,
                                            "payment_types",
                                        );
                                    }

                                    }
                                    onRemove={(e) => {
                                        onSelectValue(
                                            e,
                                            "payment_types",
                                        );
                                    }}
                                    selectedValues={
                                        Object.prototype.hasOwnProperty.call(
                                            selectedFormObj,
                                            "payment_types"
                                        )
                                            ?
                                            selectedFormObj?.payment_types
                                            : []
                                    }
                                    displayValue={"name"}
                                />
                            </Form.Group>
                        </Col> */}
              <Col xs={12} md={12} lg={12} className="px-3">
                {/* <Form.Group className="mb-3  w-100" controlId="formBasicEmail">
                                <Form.Label>
                                    {"Upload Variant Images"}
                                    {!isUpdateMode ? (
                                        <span className="redStreSpan">{"*"}</span>
                                    ) : (
                                        ""
                                    )}
                                </Form.Label>
                                <Form.Control
                                    type="file"
                                    multiple
                                    required={!isUpdateMode ? true : false}
                                // onChange={(e) => handleFileChange(e, variant.quantity)}

                                />
                            </Form.Group>
                             */}

                <CustomDragDrop onUplodfiles={handleFileChange} />
                {isUpdateMode && (
                  <CustomImagesDrageDrop
                    imagesArray={selectedFormObj?.productImages}
                    onChange={onSelectValue}
                  />
                )}
              </Col>
            </Row>
            <div className="action-buttons">
              <CustomButton
                buttonClasses="close-btn"
                onClick={() => setShowVariantCRUD(false)}
                disabled={requestCall?.loading}
              >
                {"Back"}
              </CustomButton>
              <CustomButton
                variant="primary"
                buttonClasses={!requestCall?.loading ? "submit-btn" : "submit-btn-loading"}
                type="submit"
                loading={requestCall?.loading}
              >
                {!isUpdateMode ? "Add" : "update"}
              </CustomButton>
            </div>
          </Form>
        )}
      </Row>
    </>
  );
};

export default VariantsCrud;
